import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { EventNotificationService, useTransientStatefulEventNotification } from "../framework/services/event-notification";

export enum ShopAppEvents {
    ForceSignIn = 'ShopApp.ForceSignIn',
    ProjectConfigDidUpdate = 'ShopApp.ProjectConfigDidUpdate',
    UpdateHeaderConfiguration = 'ShopApp.UpdateHeaderConfiguration',
    ShowAppLoadingWithMessage = 'ShopApp.ShowAppLoadingWithMessage',
    ShowShoppingCartPanel = 'ShopApp.ShowShoppingCartPanel',
    ShowProjectAccountPanel = 'ShopApp.ShowProjectAccountPanel',
    ShowAppReady = 'ShopApp.ShowAppReady',
    ShowColorPrefsPanel = 'ShopApp.ShowColorPrefsPanel',
    ToggleColorPrefsPanel = 'ShopApp.ToggleColorPrefsPanel',
    DoorSortPreferenceDidChange = 'ShopApp.DoorSortPreferenceDidChange',
    ToggleLoadingOverlay = 'ShopApp.ToggleLoadingOverlay',
}

export const fireToggleShoppingPrefsPanel = (showPanel: boolean) => {
    EventNotificationService.safeDispatch(ShopAppEvents.ToggleColorPrefsPanel, showPanel);
}
export function useToggleShoppingPrefsPanel(subscriberId: string) {
    return useTransientStatefulEventNotification<boolean>(ShopAppEvents.ToggleColorPrefsPanel, subscriberId);
}

export const fireShowColorPrefsPanel = (pc: IProjectConfiguration) => {
    EventNotificationService.safeDispatch(ShopAppEvents.ShowColorPrefsPanel, pc);
}
export function useShowColorPrefsPanel(subscriberId: string) {
    return useTransientStatefulEventNotification<IProjectConfiguration>(ShopAppEvents.ShowColorPrefsPanel, subscriberId);
}

export const fireToggleLoadingOverlay = (display: boolean, message?: string) => {
    EventNotificationService.safeDispatch(ShopAppEvents.ToggleLoadingOverlay, { display, message });
}
export function useToggleLoadingOverlay(subscriberId: string) {
    return useTransientStatefulEventNotification<{ display: boolean, message?: string }>(ShopAppEvents.ToggleLoadingOverlay, subscriberId);
}